import { render, staticRenderFns } from "./PpeRegisterMultipleSignatureRequest.vue?vue&type=template&id=0cc5f0b8&"
import script from "./PpeRegisterMultipleSignatureRequest.vue?vue&type=script&lang=js&"
export * from "./PpeRegisterMultipleSignatureRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports